import { LocalizationProvider } from '@mui/x-date-pickers';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fr } from 'date-fns/locale/fr';
import { frFR } from '@mui/x-date-pickers/locales';
import { Suspense } from 'react';
import { CircularProgress } from '@mui/material';
import i18n from 'i18next';
import useAuthProvider from './hooks/useAuth/useAuthProvider';
import { CustomApolloProvider } from './providers/CustomApolloProvider';
import CustomThemeProvider from './providers/CustomThemeProvider';
import useKheopsRoutes from './hooks/useKheopsRoutes';

export default function App(): React.JSX.Element {
  const routes = useKheopsRoutes();
  const router = createBrowserRouter(routes);

  useAuthProvider();

  return (
    <Suspense fallback={<CircularProgress />}>
      <CustomApolloProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr} localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}>
          <CustomThemeProvider>
            <GoogleOAuthProvider clientId={import.meta.env.REACT_APP_GOOGLE_CLIENT_ID} locale={i18n.resolvedLanguage}>
              <RouterProvider router={router} />
            </GoogleOAuthProvider>
          </CustomThemeProvider>
        </LocalizationProvider>
      </CustomApolloProvider>
    </Suspense>
  );
}
